import { render, staticRenderFns } from "./text-field-secondary.vue?vue&type=template&id=9a5efcfc"
import script from "./text-field-secondary.vue?vue&type=script&lang=js"
export * from "./text-field-secondary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports